/* ==========================================================================
   SYRUP VISION — comportamenti del tema
   Vanilla, senza dipendenze. Tutto è opzionale: se un nodo non c'è, il
   blocco relativo non fa nulla e la pagina resta funzionante.
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Menu mobile
     ------------------------------------------------------------------ */

  function initMenu() {
    var toggle = document.querySelector('[data-sy-menu-toggle]');
    var menu = document.querySelector('[data-sy-menu]');
    var header = document.querySelector('[data-sy-header]');
    if (!toggle || !menu || menu.dataset.syMenuBound) return;
    menu.dataset.syMenuBound = '1';

    function set(open) {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Chiudi il menu' : 'Menu');
      if (open) menu.setAttribute('data-open', '');
      else menu.removeAttribute('data-open');
      if (header) header.classList.toggle('is-menu-open', open);
      // la pagina sotto non scorre mentre il foglio è giù
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    toggle.addEventListener('click', function () {
      set(toggle.getAttribute('aria-expanded') !== 'true');
    });

    // toccando il fondo scuro, fuori dal foglio
    menu.addEventListener('click', function (event) {
      if (event.target === menu) set(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.hasAttribute('data-open')) set(false);
    });
  }

  /* ------------------------------------------------------------------
     Header: le gocce solo in cima
     Appena la pagina si muove l'header diventa una barra normale. La
     soglia è alta quanto l'header stesso: entro quel primo pezzo di
     scroll la colata sta ancora sopra la foto e ha senso, dopo no.
     ------------------------------------------------------------------ */

  function initHeaderScroll() {
    var header = document.querySelector('[data-sy-header]');
    // Il theme editor richiama init() a ogni ricarica di sezione: senza
    // questo si accumulerebbe un listener di scroll per volta.
    if (!header || header.dataset.syHeaderBound) return;
    header.dataset.syHeaderBound = '1';

    var threshold = header.offsetHeight || 64;
    var ticking = false;
    var scrolled = null;

    function apply() {
      ticking = false;
      var now = window.scrollY > threshold * 0.4;
      // Solo sul cambio: toccare la classe a ogni frame farebbe ripartire
      // la transizione del ritiro da capo.
      if (now === scrolled) return;
      scrolled = now;
      header.classList.toggle('is-scrolled', now);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(apply);
      },
      { passive: true }
    );

    // Ricaricando a metà pagina si riparte già scrollati.
    apply();
  }

  /* ------------------------------------------------------------------
     Filtri della collezione
     Il form è un GET normale che ricarica la pagina: qui non si tiene
     nessuno stato, si tolgono solo due attriti. Uno, il form si manda da
     solo quando si tocca una casella, così sparisce il bottone "Applica"
     (che senza JS resta e funziona). Due, su telefono la colonna parte
     chiusa, se no si scorrerebbero tutti i filtri prima del primo capo.
     ------------------------------------------------------------------ */

  function initFilters() {
    var panel = document.querySelector('[data-sy-filters-panel]');
    // Il theme editor richiama init() a ogni ricarica di sezione: senza
    // questo si accumulerebbero i listener, uno per volta.
    if (panel && !panel.dataset.syFiltersBound && window.matchMedia) {
      panel.dataset.syFiltersBound = '1';
      var narrow = window.matchMedia('(max-width: 989px)');
      var sync = function () {
        // Da tablet in su la maniglia è nascosta dal CSS: se restasse
        // chiusa, i filtri sparirebbero senza modo di riaprirli.
        panel.open = !narrow.matches;
      };
      sync();
      if (narrow.addEventListener) narrow.addEventListener('change', sync);
      else if (narrow.addListener) narrow.addListener(sync);
    }

    var form = document.querySelector('[data-sy-filters]');
    if (!form || form.dataset.syFiltersBound) return;
    form.dataset.syFiltersBound = '1';
    form.classList.add('is-live');

    // Ascolto sul documento e non sul form: il menù dell'ordinamento sta
    // sopra la griglia, fuori dal form, ed è legato con l'attributo form=.
    // I suoi eventi non passano di qui, ma il suo .form sì.
    document.addEventListener('change', function (event) {
      var field = event.target;
      if (!field || field.form !== form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ------------------------------------------------------------------
     Fit-to-width dei titoli display
     Il display gigante deve toccare i due bordi qualunque sia il testo:
     con un font-size fisso "DOUBLE" e "CUP" darebbero due larghezze
     diverse. Misuro il testo a 100px e riscalo in proporzione.
     ------------------------------------------------------------------ */

  function fitOne(span) {
    var box = span.parentElement;
    if (!box) return;

    // --sy-fit-scale permette di non riempire tutta la riga: il titolo
    // della sezione bicchiere sta al 72% perché a piena larghezza si
    // mangiava tutto lo schermo.
    var scale = parseFloat(getComputedStyle(span).getPropertyValue('--sy-fit-scale'));
    if (!(scale > 0)) scale = 1;

    var target = box.clientWidth * scale;
    if (!target) return;

    span.style.fontSize = '100px';
    var natural = span.getBoundingClientRect().width;
    if (!natural) return;

    // 24px di pavimento: su schermi strettissimi un testo lungo si
    // rimpicciolirebbe fino a essere illeggibile.
    var size = Math.max(24, (100 * target) / natural);
    span.style.fontSize = size + 'px';

    // Secondo passaggio: la prima stima assume che la larghezza scali in
    // modo perfettamente lineare col font-size, e non è sempre vero
    // (arrotondamenti, spaziature ereditate in px, assi ottici del font
    // variabile). Misuro il risultato vero e correggo.
    var actual = span.getBoundingClientRect().width;
    if (actual > 0 && Math.abs(actual - target) > 1) {
      span.style.fontSize = Math.max(24, (size * target) / actual) + 'px';
    }
  }

  function initFitText() {
    var nodes = document.querySelectorAll('[data-sy-fit]');
    if (!nodes.length) return;

    function fitAll() {
      nodes.forEach(fitOne);
    }

    fitAll();

    // Il font variabile arriva dopo il primo paint: senza questo il
    // calcolo verrebbe fatto sul fallback di sistema e resterebbe storto.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitAll);
    }

    var pending;
    window.addEventListener('resize', function () {
      clearTimeout(pending);
      pending = setTimeout(fitAll, 120);
    });
  }

  /* ------------------------------------------------------------------
     Countdown del drop
     Il valore arriva come "AAAA-MM-GG HH:MM" ora italiana. Lo normalizzo
     in ISO con offset esplicito, altrimenti Safari lo interpreta come
     data locale del visitatore e il countdown sballa fuso per fuso.
     ------------------------------------------------------------------ */

  function parseDropDate(raw) {
    var m = String(raw).trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
    if (!m) return null;

    // L'Italia è UTC+1, UTC+2 durante l'ora legale (ultima domenica di marzo
    // → ultima domenica di ottobre). Ricavo l'offset dalla data indicata.
    var y = +m[1];
    var mo = +m[2];
    var d = +m[3];
    var offset = isItalianDst(y, mo, d) ? '+02:00' : '+01:00';
    var date = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + m[4] + ':' + m[5] + ':00' + offset);
    return isNaN(date.getTime()) ? null : date;
  }

  function lastSundayOfMonth(year, month) {
    // month è 1-based. Il giorno 0 del mese successivo = ultimo giorno di questo.
    var last = new Date(Date.UTC(year, month, 0));
    return last.getUTCDate() - last.getUTCDay();
  }

  function isItalianDst(y, mo, d) {
    if (mo < 3 || mo > 10) return false;
    if (mo > 3 && mo < 10) return true;
    if (mo === 3) return d >= lastSundayOfMonth(y, 3);
    return d < lastSundayOfMonth(y, 10);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initCountdown() {
    var nodes = document.querySelectorAll('[data-sy-countdown]');
    if (!nodes.length) return;

    var targets = [];
    nodes.forEach(function (node) {
      var date = parseDropDate(node.getAttribute('data-sy-countdown'));
      if (date) targets.push({ node: node, date: date });
    });
    if (!targets.length) return;

    function tick() {
      targets.forEach(function (t) {
        var diff = t.date.getTime() - Date.now();
        if (diff <= 0) {
          t.node.textContent = 'LIVE';
          return;
        }
        // Formato timecode: giorni:ore:minuti:secondi, tutti a due cifre.
        // I giorni compaiono solo quando ci sono, così l'ultimo giorno il
        // conto si accorcia da solo e diventa più urgente.
        var s = Math.floor(diff / 1000);
        var days = Math.floor(s / 86400);
        var hours = Math.floor((s % 86400) / 3600);
        var mins = Math.floor((s % 3600) / 60);
        var secs = s % 60;
        t.node.textContent =
          (days > 0 ? pad(days) + ':' : '') + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------------
     Quick add dalla griglia
     I bottoni taglia sono submit di una form: senza JS il click non fa
     nulla di rotto, e con JS aggiungiamo al carrello senza cambiare pagina.
     ------------------------------------------------------------------ */

  function setCartCount(count) {
    document.querySelectorAll('[data-sy-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function flashButton(button, label) {
    var original = button.textContent;
    button.textContent = label;
    button.disabled = true;
    setTimeout(function () {
      button.textContent = original;
      button.disabled = false;
    }, 1200);
  }

  /* ------------------------------------------------------------------
     Spedizione gratis e banda "aggiunto"
     La soglia arriva dal tema (window.syrupShipping, in centesimi). Ogni
     barra con [data-sy-ship-text] / [data-sy-ship-fill] si riallinea al
     totale del carrello; la banda scende da sotto l'header a ogni
     aggiunta fatta senza cambiare pagina e risale da sola.
     ------------------------------------------------------------------ */

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function updateShipping(total) {
    var threshold = window.syrupShipping && window.syrupShipping.threshold;
    var ship = document.querySelector('[data-sy-added-ship]');
    if (ship) ship.hidden = !threshold;
    if (!threshold) return;

    var missing = threshold - total;
    var pct = Math.min(100, Math.round((total / threshold) * 100));

    document.querySelectorAll('[data-sy-ship-text]').forEach(function (el) {
      el.innerHTML = missing > 0
        ? 'Ti mancano <strong>' + formatMoney(missing) + '</strong> per la spedizione gratis.'
        : 'La spedizione è gratis.';
    });
    document.querySelectorAll('[data-sy-ship-fill]').forEach(function (el) {
      el.style.setProperty('--pct', pct + '%');
    });
    document.querySelectorAll('[data-sy-ship]').forEach(function (el) {
      el.classList.toggle('sy-ship--done', missing <= 0);
    });
    document.querySelectorAll('[data-sy-ship-track]').forEach(function (el) {
      el.setAttribute('aria-valuenow', pct);
    });
  }

  var addedTimer;

  function showAdded(item, cart) {
    var band = document.querySelector('[data-sy-added]');
    if (!band) return;

    var name = band.querySelector('[data-sy-added-name]');
    if (name && item) {
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
      name.textContent = item.product_title + variant;
    }

    // Il pieno parte da dove era, così si vede salire.
    updateShipping(cart.total_price);
    band.setAttribute('data-open', '');

    clearTimeout(addedTimer);
    addedTimer = setTimeout(function () {
      band.removeAttribute('data-open');
    }, 6000);
  }

  function initAddedBand() {
    var band = document.querySelector('[data-sy-added]');
    if (!band || band.dataset.syAddedBound) return;
    band.dataset.syAddedBound = '1';

    band.addEventListener('click', function (event) {
      if (event.target.closest('[data-sy-added-close]')) {
        clearTimeout(addedTimer);
        band.removeAttribute('data-open');
      }
    });
    // Col mouse sopra non scappa via mentre la leggi.
    band.addEventListener('mouseenter', function () {
      clearTimeout(addedTimer);
    });
    band.addEventListener('mouseleave', function () {
      if (!band.hasAttribute('data-open')) return;
      addedTimer = setTimeout(function () {
        band.removeAttribute('data-open');
      }, 2500);
    });
  }

  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  // Aggiunge, rilegge il carrello, aggiorna il contatore e fa colare la banda.
  function addToCart(body, isJson) {
    var added;
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: isJson
        ? { 'Content-Type': 'application/json', Accept: 'application/json' }
        : { Accept: 'application/json' },
      body: body
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add-to-cart failed');
        return res.json();
      })
      .then(function (data) {
        added = data.items ? data.items[0] : data;
        return fetch(cartRoot() + 'cart.js');
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        showAdded(added, cart);
        return cart;
      });
  }

  function initQuickAdd() {
    document.querySelectorAll('[data-sy-quick-add]').forEach(function (form) {
      form.addEventListener('click', function (event) {
        var button = event.target.closest('button[name="id"]');
        if (!button || button.disabled) return;

        event.preventDefault();

        addToCart(JSON.stringify({ items: [{ id: Number(button.value), quantity: 1 }] }), true)
          .then(function () {
            flashButton(button, '✓');
          })
          .catch(function () {
            flashButton(button, '!');
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     Scelta taglia nella pagina prodotto
     Il bottone parte spento e dice cosa manca ("Scegli la taglia"): meglio
     di un bottone acceso che al click apre un avviso. Senza JS resta
     spento, ma la form ha comunque una variante selezionata di default
     lato server, quindi l'ordine passa lo stesso.
     ------------------------------------------------------------------ */

  function initSizePicker() {
    document.querySelectorAll('[data-sy-picker]').forEach(function (picker) {
      var input = picker.querySelector('[data-sy-variant]');
      var submit = picker.querySelector('[data-sy-submit]');
      var label = picker.querySelector('[data-sy-submit-label]');
      var sizes = picker.querySelectorAll('[data-sy-size]');
      if (!sizes.length || !submit) return;

      submit.disabled = true;

      picker.addEventListener('click', function (event) {
        var button = event.target.closest('[data-sy-size]');
        if (!button || button.disabled) return;

        event.preventDefault();

        sizes.forEach(function (other) {
          other.setAttribute('aria-pressed', String(other === button));
        });

        if (input) input.value = button.value;
        submit.disabled = false;
        if (label) label.textContent = label.getAttribute('data-sy-submit-label') || 'Aggiungi';
      });

      // Con il JS si resta sulla scheda: il capo entra, cola la banda con
      // quanto manca alla spedizione gratis. Senza JS la form va a /cart.
      if (picker.dataset.syPickerBound) return;
      picker.dataset.syPickerBound = '1';
      picker.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData) return;
        event.preventDefault();
        submit.disabled = true;

        addToCart(new FormData(picker), false)
          .then(function () {
            submit.disabled = false;
          })
          .catch(function () {
            // qualcosa è andato storto: si torna alla strada normale
            picker.submit();
          });
      });
    });
  }

  /* ------------------------------------------------------------------ */

  /* Pop-up iscrizione. Torna a ogni visita: chi lo chiude non lo rivede
     finché gira fra le pagine, ma alla visita dopo sì. Chi si iscrive non
     lo rivede più. Se il form è stato inviato Shopify ricarica con il
     pannello già aperto sul codice, e lì non tocchiamo niente. */
  function initPopup() {
    var pop = document.querySelector('[data-sy-pop]');
    if (!pop || pop.dataset.syPopBound) return;
    pop.dataset.syPopBound = '1';

    // Chiave nuova per gli iscritti: la vecchia 'sy-pop-seen' in
    // localStorage la prendeva anche chi l'aveva solo chiuso.
    var KEY = 'sy-pop-seen';
    var JOINED = 'sy-pop-joined';
    var timer;

    function seen() {
      try {
        return localStorage.getItem(JOINED) === '1' || sessionStorage.getItem(KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    // chiuso: basta per questa visita
    function dismiss() {
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {
        /* navigazione privata: pazienza, ricomparirà */
      }
    }

    // iscritto: basta per sempre
    function remember() {
      try {
        localStorage.setItem(JOINED, '1');
      } catch (e) {
        /* navigazione privata: pazienza, ricomparirà */
      }
    }

    function open() {
      pop.setAttribute('data-open', '');
      var field = pop.querySelector('input[type="email"]');
      if (field) field.focus();
    }

    function close() {
      clearTimeout(timer);
      pop.removeAttribute('data-open');
      dismiss();
    }

    // ?pop in coda all'indirizzo lo riapre sempre, anche se è già stato
    // chiuso: serve per guardarlo senza svuotare il localStorage a mano.
    var forced = location.search.indexOf('pop') !== -1;

    if (pop.hasAttribute('data-done')) {
      remember();
    } else if (forced) {
      timer = setTimeout(open, 150);
    } else if (!seen()) {
      var delay = parseInt(pop.getAttribute('data-sy-pop-delay'), 10);
      timer = setTimeout(open, isNaN(delay) ? 8000 : delay);
    }

    pop.addEventListener('click', function (event) {
      // fuori dal pannello o sulla X
      if (event.target === pop || event.target.closest('[data-sy-pop-close]')) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && pop.hasAttribute('data-open')) close();
    });

    // chi si iscrive non deve rivederlo, anche prima del ricaricamento
    pop.addEventListener('submit', remember);
  }

  /* ------------------------------------------------------------------
     Carrello
     Senza JS la quantità scritta a mano parte col bottone "Aggiorna".
     Qui il campo si manda da solo appena cambia, e il bottone sparisce.
     ------------------------------------------------------------------ */

  function initCart() {
    var form = document.querySelector('[data-sy-cart]');
    if (!form || form.dataset.syCartBound) return;
    form.dataset.syCartBound = '1';

    var update = form.querySelector('[data-sy-cart-update]');
    if (update) update.hidden = true;

    form.addEventListener('change', function (event) {
      if (event.target.matches('[data-sy-cart-qty]')) form.submit();
    });
  }

  /* ------------------------------------------------------------------
     Slider delle foto prodotto sul telefono: lo scorrimento è quello
     nativo del browser (scroll-snap in syrup.css §15), qui ci sono il
     contatore e le miniature sotto. Le frecce, se ci sono, si spengono
     ai due capi.
     ------------------------------------------------------------------ */
  function initSlider() {
    document.querySelectorAll('[data-sy-slider]').forEach(function (track) {
      if (track.dataset.sySliderBound) return;
      track.dataset.sySliderBound = '1';

      var root = track.closest('.sy-pdp__gallery') || track.parentElement;
      var index = root.querySelector('[data-sy-slide-index]');
      var thumbs = root.querySelector('[data-sy-thumbs]');
      var shown = -1;
      var prev = root.querySelector('[data-sy-slide="-1"]');
      var next = root.querySelector('[data-sy-slide="1"]');
      var total = track.children.length;

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      function sync() {
        var i = current();
        if (index) index.textContent = i + 1;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= total - 1;
        if (thumbs && i !== shown) {
          shown = i;
          thumbs.querySelectorAll('[data-sy-thumb]').forEach(function (thumb, n) {
            thumb.setAttribute('aria-current', n === i ? 'true' : 'false');
            // La fila scorre da sola per tenere in vista la miniatura attiva.
            if (n === i) {
              var left = thumb.offsetLeft - (thumbs.clientWidth - thumb.offsetWidth) / 2;
              thumbs.scrollTo({ left: left, behavior: 'smooth' });
            }
          });
        }
      }

      root.querySelectorAll('[data-sy-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          track.scrollTo({ left: Number(thumb.dataset.syThumb) * track.clientWidth, behavior: 'smooth' });
        });
      });

      root.querySelectorAll('[data-sy-slide]').forEach(function (button) {
        button.addEventListener('click', function () {
          var i = current() + Number(button.dataset.sySlide);
          track.scrollTo({ left: i * track.clientWidth });
        });
      });

      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  /* ------------------------------------------------------------------ */

  function init() {
    initMenu();
    initHeaderScroll();
    initFilters();
    initFitText();
    initCountdown();
    initQuickAdd();
    initSizePicker();
    initPopup();
    initCart();
    initAddedBand();
    initSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Il theme editor ricarica le sezioni via XHR: ricablo i listener.
  document.addEventListener('shopify:section:load', init);
})();
